<template>
  <simple-page header="用户管理" @query="query">
    <template #buttons>
      <btn-add @click="edit()"></btn-add>
    </template>
    <template #form>
      <el-form inline>
        <el-form-item label="单位名称">
          <comp-select v-model="queryForm.compId"
                       style="width: 300px"
                       @change="query"></comp-select>
        </el-form-item>
        <el-form-item label="用户信息">
          <el-input v-model="queryForm.userInfo" placeholder="用户信息模糊搜索" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="queryForm.valid" clearable @change="query">
            <el-option :value="true" label="启用"></el-option>
            <el-option :value="false" label="禁用"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </template>

    <el-table stripe :data="records" :border="true" v-loading="loading">
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <el-table-column prop="userName" label="用户姓名" align="center" min-width="150"></el-table-column>
      <el-table-column prop="loginName" label="登录帐号" align="center" min-width="150"></el-table-column>
<!--        <el-table-column prop="compTypeName" label="单位类型" align="center" min-width="100"></el-table-column>-->
      <el-table-column prop="compName" label="所属单位" min-width="180"></el-table-column>
      <el-table-column prop="valid" label="状态" align="center" width="100" v-slot="{row}">
        <span v-if="row.valid" class="color-success">启用</span>
        <span v-else class="color-error">禁用</span>
      </el-table-column>
      <el-table-column prop="compCount" label="已授权单位" align="center" width="100"></el-table-column>
      <el-table-column prop="action" label="操作" width="250" align="center" fixed="right" v-slot="{row}">
        <el-button type="primary" size="small" @click="edit(row)">编辑</el-button>
        <el-button type="primary" size="small" @click="role(row)">授权角色</el-button>
        <el-button type="primary" size="small" @click="showUserComp(row)">授权单位</el-button>
        <el-button type="danger" size="small" @click="del(row)">删除</el-button>
      </el-table-column>
    </el-table>
    <table-pagination :page-query="queryForm" :total="total" @change="loadData"></table-pagination>
  </simple-page>
</template>

<script>
import TitleBar from "@/components/base/TitleBar";
import TablePagination from "@/components/base/TablePagination";
import BaseVue from "@/components/base/BaseVue";
import CodeSelect from "@/components/base/CodeSelect";
import CompSelect from "@/components/base/CompSelect";
import SimplePage from "@/components/page/SimplePage.vue";
import BtnAdd from "@/components/btns/BtnAdd.vue";
export default {
  components: { BtnAdd, SimplePage, CompSelect, CodeSelect, TablePagination, TitleBar},
  extends: BaseVue,
  data() {
    return {
      editing: false,
      queryForm: {
        compId: '',
        userInfo: '',
        valid: null,
        page: 1,
        limit: 10
      },
      total: 0,
      records: []
    }
  },
  created() {
    //重置缓存
    let cache = this.getComponentCache();
    if(cache) {
        this.queryForm = cache;
    }
    this.clearComponentCache();
    this.loadData();
  },
  methods: {
    query(){
      this.queryForm.page = 1;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.postForm("/user/getUserList", this.queryForm, true).then(dr => {
        this.records = dr.rows;
        this.total = dr.total;
      }).finally(()=>{
        this.loading = false;
      })
    },
    edit(row) {
      this.saveCache();
      this.$router.push({
        path: "/userEdit",
        query: {
          userId: row ? row.userId: null
        }
      })
    },
    //授权
    role(row) {
      this.saveCache();
      this.$router.push({
        path: "/userRole",
        query: {
          userId: row.userId
        }
      });
    },
    //授权单位
    showUserComp(row){
      this.saveCache();
      this.$router.push({
        path: "/userComp",
        query: {
          userId: row.userId
        }
      });
    },
    saveCache() {
      this.setComponentCache(this.queryForm);
    },
    del(row){
      this.$confirm("确定要删除该用户吗？").then(()=>{
        this.loading = true;
        this.postForm("/user/deleteUser", {
          userId: row.userId
        }, true).then(dr => {
          this.records = dr.rows;
          this.total = dr.total;
        }).finally(()=>{
          this.loading = false;
        })
      });
    }
  }
}
</script>

<style scoped>

</style>